import React from 'react';
import { ISVGType } from './SVGType';

const DownArrowSVG = (props: ISVGType) => {
  const { width = 8, height = 10, color = "#F44336" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 8 10"
      fill="none"
    >
      <path
        d="M4.66413 7.50621C4.88161 7.26325 5.08137 7.03987 5.28149 6.81685C5.69356 6.35826 6.10082 5.89562 6.52101 5.44478C6.69122 5.26201 6.84593 5.05561 7.12175 4.99875C7.44335 4.93229 7.88938 5.15789 7.93332 5.59543C7.9636 5.89635 7.80298 6.10792 7.61578 6.31137C7.21332 6.74891 6.81196 7.18756 6.41171 7.62732C6.16913 7.8939 5.9306 8.16455 5.68876 8.43188C5.33023 8.82843 4.96543 9.21982 4.61429 9.62265C4.48136 9.77515 4.35878 9.9221 4.14942 9.97342C3.90019 10.0347 3.6757 9.99373 3.49994 9.81133C3.12813 9.42548 2.76849 9.02782 2.40295 8.63569C2.00603 8.20997 1.60799 7.78535 1.21107 7.35962C0.992483 7.12516 0.773897 6.8907 0.558265 6.65365C0.420172 6.50226 0.282817 6.34977 0.153586 6.19063C-0.165431 5.7974 0.0365388 5.23136 0.535742 5.10287C0.761343 5.04453 1.00171 5.09401 1.17673 5.27863C1.58399 5.70731 1.98609 6.14079 2.38929 6.57316C2.61083 6.81094 2.83126 7.04984 3.05059 7.28984C3.12074 7.36627 3.18646 7.44676 3.27914 7.55421C3.27914 7.47335 3.27914 7.42572 3.27914 7.37809C3.27914 5.14423 3.28025 2.91037 3.27914 0.676508C3.27914 0.33829 3.51065 0.114905 3.78758 0.0277656C4.19115 -0.0992505 4.67004 0.221982 4.6682 0.736693C4.65897 2.93363 4.66413 5.13056 4.66413 7.3275L4.66413 7.50621Z"
        fill={color}
      />
    </svg>
  )
};

export default DownArrowSVG;
